<style lang="sass" scoped>
.p-main
    padding: 20px 20px 60px
    position: relative
    .page
        position: absolute
        bottom: 10px
        left: 0
        width: 100%
        padding: 0 20px

.cp-tabs
    text-align: left
    .cp-tab
        float: left
        width: 160px
        height: 40px
        line-height: 38px
        background: #fff
        border: 1px solid #e9e9e9
        border-bottom: none
        border-radius: 4px 4px 0 0
        margin-right: 10px
        cursor: pointer
        text-align: center
        position: relative
        &.cur
            border: none
            background: linear-gradient(315deg,rgba(250,234,97,1) 0%,rgba(255,184,31,1) 100%)
            border-radius: 4px 4px 0px 0px
            span
                color: #282729
        span
            color: #999
        .red
            position: absolute
            right: 0
            top: 0
            width: 6px
            height: 6px
            border-radius: 50%
            background: #FF3973

.cp-main
    padding: 20px
    background: #fff
    border: 1px solid #e9e9e9
    height: calc(100% - 30px)
    position: relative
    overflow: hidden
    &:hover
        overflow: auto
    .cp-item
        width: 100%
        min-height: 100px
        border: 1px solid #e9e9e9
        margin-bottom: 10px
        padding: 20px 0
        font-weight: 400
        font-size: 16px
        padding: 10px 20px
        position: relative
        cursor: pointer
        &:hover
            background: #f5f5f5
            border: 1px solid #f5f5f5
            padding: 10px 40px 10px 20px
            .del
                display: block
        .del
            display: none
            position: absolute
            font-size: 24px
            color: #d4d4d4
            cursor: pointer
            right: 20px
            top: 50%
            margin-top: -12px
        .msg-title
            margin-bottom: 10px
            font-weight: 550
            &.read
                color: #999
                font-weight: normal
        .msg-time
            color: #999
            font-size: 14px
            margin-top: 10px
.tip-main
    margin-top: 60px
    text-align: center
    font-size: 16px
.details
    padding: 0 20px
.close_btn
    cursor: pointer
    float: right
    font-size: 22px
    font-weight: 400
</style>

<template lang="pug">
    div
        .p-title 我的消息
        .p-main
            .cp-tabs
                .cp-tab(
                    v-for="(item, i) in [{dictItemName: '全部', dictItemCode: ''}, ...types]"
                    @click="clickType(item, i)"
                    :class="{'cur':cpTab==i}"
                ) {{item.dictItemName}}
                    .red(v-if="showRedPoint(item)")
                .clear
            .cp-main
                .cp-item(v-for="(item, i) in msgList" :key="i" @click="msgClick(item,$event)")
                    .msg-title.els(v-html="item.title" :class="{read: item.isRead == 1}")
                    .msg-content(v-html="item.content")
                    .msg-time {{item.sendTime | timeNoS}}
                    i.del.el-icon-close(@click.stop="showDel(item)")

            page.page(:currentPage.sync="page" :size.sync="size" @fn-change="getList" :total="total")

        fix-center(ref="del" w="400" h="300")
            template(slot="title") 温馨提示
            .tip-main(slot="main") 确定要删除这条消息？
            template(slot="btm")
                .fix-btn.red(@click="delMsg") 确认
                .fix-btn(@click="hideDel") 取消

        fix-center(ref="monit" w="400" h="340")
            template(slot="title") 消息详情
                span.close_btn(@click="$refs.monit.hide()") ×
            .details(slot="main" v-html="textDetail")
            template(slot="btm")
                el-button(size="mini" @click="$refs.monit.hide()" style="width:120px;margin-top:15px") 确定
</template>

<script>
import Page from '../components/Pagination'
export default {
    name: 'message',
    components: { Page },
    data(){
        return {
            cpTab: 0,
            msgList: [],
            curItem: null,
            page: 1,
            size: 20,
            total: 0,
            types: [],
            curType: '',
            textDetail: ''
        }
    },
    computed: {
        hasNoReadMsg(){
            return this.$store.state.common.hasNoReadMsg
        },
        showRedPoint () {
            let hasNoReadMsg = this.hasNoReadMsg
            return item => {
                if (!hasNoReadMsg || hasNoReadMsg.length === 0) return false
                return hasNoReadMsg.map(el => el.messageTypeCode || el.messageType).indexOf(item.dictItemCode) > -1
            }
        }
    },
    watch: {
        hasNoReadMsg (v) {
            if (v && v.length > 0) {
            } else {
            }
        }
    },
    methods: {
        async msgClick (item, event) {
            // 新用户注册福利  11   邀请好友奖励  12    佣金到账提醒  13    充值成功提醒  18
            // 未上传素材提醒  14  素材审核提醒  17  素材未上传  170    素材待审核  171   素材审核通过  172  素材审核失败  173
            // 优惠券过期提醒  15
            // 账号认证失败  161   账号认证成功  162
            // 版本更新  21
            // 活动消息  00
            if (item.isRead == 0) {  // 如果是未读的，
                // await 设置已读之后再请求所有未读的
                await this.setRead(item.id, true)
                this.$store.dispatch('getMsgTipStatu') // 更新消息提示状态
            }
            
            if (event.target.hasAttribute('href')) return // 点击监播消息中的链接

            if (item.actionType === '00') {
                this.goUrl(item.action)
            } else if (item.contentType === '251') { // 监播站内信，点击弹出详情
                this.textDetail = item.contentDetaile || ''
                this.$refs.monit.show()
            } else {
                // 设置成已读
                this.$set(item, 'isRead', 1)
            }

            // let moneyTypes = ['11', '12', '13', '18'],
            //     orderUrls = ['14', '17', '170', '171', '172', '173'],
            //     couponUrls = ['15'],
            //     accountUrls = ['161', '162']
            // if (moneyTypes.indexOf(item.contentType) > -1) {
            //     // 充值记录
            //     this.goUrl('/rechargeList')
            // } else if (orderUrls.indexOf(item.contentType) > -1) {
            //     // 广告发布
            //     this.goUrl('/orderVideo')
            // } else if (couponUrls.indexOf(item.contentType) > -1) {
            //     // 优惠券
            //     this.goUrl('/coupon')
            // } else if (accountUrls.indexOf(item.contentType) > -1) {
            //     // 账户信息
            //     this.goUrl('/accountInfo')
            // } else {
            //     // 设置成已读
            //     this.$set(item, 'isRead', 1)
            // }
        },
        clickType(item, i){
            this.cpTab = i
            this.curType = item.dictItemCode
            this.page = 1
            this.total = 0
            this.getList()
        },
        async getTypes() {
            if(!this.$store.state.common.ADVERTMESSAGETYPE.length) await this.$store.dispatch('getDictItemList', 'ADVERTMESSAGETYPE')
            this.types = this.$store.state.common.ADVERTMESSAGETYPE
        },
        async delMsg(){
            let res = await this.fetch('/boss/message/v2/deleteMessages?ids='+this.curItem.id, '', 'DELETE')
            if(res && res.code == this.successCode){
                this.getList()
                this.hideDel()
                this.messageTip(res.msg ? res.msg : '操作成功', 1)
            }else this.messageTip(res && res.msg ? res.msg : '请稍后重试')
        },
        showDel(item){
            this.curItem = item
            this.$refs.del.show()
        },
        hideDel(){
            this.curItem = null
            this.$refs.del.hide()
        },
        async getList(){
            if(!this.types || this.types.length == 0) await this.getTypes()
            this.msgList = []
            this.total = 0
            let opt = {
                pageIndex: this.page,
                pageSize: this.size
            }
            if (this.curType) opt.messageType = this.curType
            let res = await this.fetch('/boss/message/v2/getMessagePage', opt)
            if(res && res.code == this.successCode){
                this.msgList = res.data.list || []
                this.total = res.data.total || 0

                // 暂无触发已读的操作，这里先自动把所有的请求到的数据都设置成已读
                // this.msgList.length > 0 && await this.setRead(this.msgList.map(el=>el.id))
                // this.$store.dispatch('getMsgTipStatu') // 更新消息提示状态
            }
        },
        async setRead(guids, isOne){
            if(isOne) {
                await this.fetch('/boss/message/v2/viewMessages?ids='+guids, '', 'get')
            } else {
                await this.fetch('/boss/message/v2/viewMessages?ids='+guids.join(','), '', 'get')
            }
        }
    }
}
</script>
